import { IEntity } from './IEntity';

export const resourceNameGameIdentityGoal = `gameidentitygoal`;

export interface IGameIdentityGoal extends IEntity {
	gameidentityid: number;
	goalid: number;
}
